// Helpers for consistent number formatting with thin-space group separators

const THIN_SPACE = '\u202f';

const DEFAULT_NUMBER_FORMAT_OPTIONS: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

export const formatNumber = (
  value: number,
  options: Intl.NumberFormatOptions = DEFAULT_NUMBER_FORMAT_OPTIONS,
) => {
  if (!Number.isFinite(value)) {
    return '-';
  }

  return new Intl.NumberFormat('en-US', {
    useGrouping: true,
    ...DEFAULT_NUMBER_FORMAT_OPTIONS,
    ...options,
  })
    .format(value)
    .replace(/,/g, THIN_SPACE);
};

export const formatOptionalNumber = (
  value: number | null,
  options: Intl.NumberFormatOptions = DEFAULT_NUMBER_FORMAT_OPTIONS,
) => {
  return value === null ? '-' : formatNumber(value, options);
};

export const parseKvNumber = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
